import React, { useContext, useState, useEffect } from "react";
import { Grid, Typography } from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
// import { Contexts } from "../contexts";
import { formatNumber, formatDate } from "../../Utils/utils";
import { DataTabs } from "../LabTabs";
import Alert from "@mui/material/Alert";
import {isTestEnv} from "../../globals";

export const CollateralDetails = ({ collateralDetails, statusError }) => {
  const [expandedPanel, setExpandedPanel] = useState(false);
  const handleChange = (event, isExpanded) => {
    setExpandedPanel(isExpanded);
  };
  const CDetails = collateralDetails?.map((row, index) => ({
    ...row,
    id: index,
    TOVALIDDATE: row["TOVALIDDATE"] ? new Date(row["TOVALIDDATE"]) : null,
    FROMVALIDDATE: new Date(row["FROMVALIDDATE"])
  }));
  isTestEnv && console.log("collateralDetails", collateralDetails);
  const dataGridColumns = [
    { field: "BAILTYPECODE", headerName: "קוד ערבות", width: 90 },
    {
      field: "BAILTYPEDES",
      headerName: "תאור ערבות",
      width: 150,
    },
    {
      field: "REQSUM",
      headerName: "סכום מבוקש",
      width: 150,
      renderCell: (params) => formatNumber(params.value),
    },
    {
      field: "APPSUM",
      headerName: "סכום מאושר",
      width: 110,
      renderCell: (params) => formatNumber(params.value),
    },
    {
      field: "FROMVALIDDATE",
      headerName: "מתאריך",
      width: 160,
      type: 'date',
    },
    {
      field: "TOVALIDDATE",
      headerName: "עד תאריך",
      width: 160,
      type: 'date',
    },
    { field: "COMPANYNAME", headerName: "מספר חברה" },
  ];

  return (
    <Accordion expanded={expandedPanel} onChange={handleChange} disabled={collateralDetails===null}>
      <AccordionSummary
        expandIcon={<ArrowDropDownIcon />}
        aria-controls="panel6-content"
        id="panel6-header"
        style={{
          backgroundColor: expandedPanel ? "#f0f0f0" : "inherit",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            padding: "5px",
            borderRadius: "5px",
          }}
        >
          <span
            style={{
              fontWeight: "bold",
              fontSize: "1.2rem",
            }}
          >
            פירוט בטוחות ללא מע"מ
          </span>
        </div>
      </AccordionSummary>
      {statusError ? (
        <Alert severity="error">אירעה תקלה. נא נסו שנית מאוחר יותר</Alert>
      ) : CDetails?.length === 0 ? (
        <Alert severity="info">אין פירוט בטוחות ללקוח</Alert>
      ) : (
        <div>
          <AccordionDetails
            style={{
              maxHeight: "calc(100vh - 100px)", // Adjust the height as needed
              // maxHeight: "300px", // Adjust the height as needed
              overflowY: "auto",
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography>
                  {dataGridColumns !== "undefined" && (
                    // <DataGridTable
                    //   columns={dataGridColumns}
                    //   rows={CDetails}
                    // />
                    <DataTabs
                      data={CDetails}
                      columns={dataGridColumns}
                      TabKey={{value: "COMPANYNAME", label: "חברה"}}
                    />
                  )}
                </Typography>
              </Grid>
            </Grid>
          </AccordionDetails>
        </div>
      )}
    </Accordion>
  );
};
